import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "../utils/motion";
type WordRevealProps = {
  text: string;
  as?: "h1" | "h2" | "h3" | "p";
  className?: string;
  delay?: number;
  immediate?: boolean;
};
export function WordReveal({
  text,
  as = "h2",
  className = "",
  delay = 0,
  immediate = false
}: WordRevealProps) {
  const reduce = useReducedMotion();
  const Tag = as;
  const words = text.split(" ");
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: reduce ? 0 : Math.min(0.05, 0.5 / words.length),
        delayChildren: reduce ? 0 : delay
      }
    }
  };
  const word = {
    hidden: {
      y: reduce ? "0%" : "105%"
    },
    show: {
      y: "0%",
      transition: {
        duration: reduce ? 0.01 : 0.8,
        ease: EASE
      }
    }
  };
  const trigger = immediate ? {
    animate: "show"
  } : {
    whileInView: "show",
    viewport: {
      once: true,
      amount: 0.4
    }
  };
  return <Tag className={className} aria-label={text} data-id="element-449" data-mp="34b2wvnxuxlyw">
      <motion.span className="block" variants={container} initial="hidden" {...trigger} aria-hidden="true" data-id="element-450" data-mp="34buh62m07x9v">
        {words.map((w, i) => <span key={`${w}-${i}`} className="inline-block overflow-hidden pb-[0.08em] align-top" data-id="element-451" data-mp="285yin373tlx3" data-mpi={i}>
            <motion.span className="inline-block" variants={word} data-id="element-452" data-mp="236c5etra05oa">
              {w}
              {i < words.length - 1 ? "\u00A0" : ""}
            </motion.span>
          </span>)}
      </motion.span>
    </Tag>;
}